import React, { useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

const BANKS = ["ING", "Deutsche Bank", "Postbank", "Commerzbank", "DZ BANK"];

export function AdminTransactionForm({ clientId, clientName, onDone }) {
  const { t } = useLanguage();
  const [busy, setBusy] = useState(false);
  const [f, setF] = useState({ purposeCode: "", purposeText: "", productType: "none", investorName: clientName || "", amount: "", currency: "EUR", targetBank: "ING", targetIban: "", targetBic: "", targetRecipient: "", settlementBank: "", notes: "" });
  const u = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const payload = { ...f, productType: f.productType === "none" ? undefined : f.productType };
      await api.post(`/admin/clients/${clientId}/transactions`, payload);
      onDone();
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
      <div className="flex flex-col gap-2"><Label>{t("portal.form.purposeCode")}</Label><Input value={f.purposeCode} onChange={u("purposeCode")} required placeholder="VZ-2026-0001" /></div>
      <div className="flex flex-col gap-2"><Label>{t("portal.form.investor")}</Label><Input value={f.investorName} onChange={u("investorName")} required /></div>
      <div className="flex flex-col gap-2"><Label>{t("admin.form.purposeText") || t("client.pay.purpose")}</Label><Input value={f.purposeText} onChange={u("purposeText")} /></div>
      <div className="flex flex-col gap-2"><Label>{t("client.pay.product")}</Label>
        <Select value={f.productType} onValueChange={(v) => setF({ ...f, productType: v })}><SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="none">{t("admin.product.none")}</SelectItem><SelectItem value="festgeld">{t("admin.product.festgeld")}</SelectItem><SelectItem value="tagesgeld">{t("admin.product.tagesgeld")}</SelectItem></SelectContent>
        </Select>
      </div>
      <div className="flex flex-col gap-2"><Label>{t("portal.form.amount")}</Label><Input type="number" step="0.01" min="0" value={f.amount} onChange={u("amount")} required /></div>
      <div className="flex flex-col gap-2"><Label>{t("portal.form.currency")}</Label>
        <Select value={f.currency} onValueChange={(v) => setF({ ...f, currency: v })}><SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent>{["EUR", "USD", "CHF", "GBP"].map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="flex flex-col gap-2"><Label>{t("portal.form.targetBank")}</Label>
        <Select value={f.targetBank} onValueChange={(v) => setF({ ...f, targetBank: v })}><SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent>{BANKS.map((b) => <SelectItem key={b} value={b}>{b}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="flex flex-col gap-2"><Label>{t("client.pay.recipient")}</Label><Input value={f.targetRecipient} onChange={u("targetRecipient")} /></div>
      <div className="flex flex-col gap-2"><Label>{t("portal.form.iban")}</Label><Input value={f.targetIban} onChange={u("targetIban")} /></div>
      <div className="flex flex-col gap-2"><Label>{t("client.pay.bic")}</Label><Input value={f.targetBic} onChange={u("targetBic")} /></div>
      <div className="flex flex-col gap-2 sm:col-span-2"><Label>{t("client.pay.settlement")}</Label><Input value={f.settlementBank} onChange={u("settlementBank")} placeholder="z. B. Deutsche Bank AG" /></div>
      <div className="flex gap-3 sm:col-span-2">
        <Button type="submit" disabled={busy}>{busy ? t("auth.wait") : t("portal.form.submit")}</Button>
        <Button type="button" variant="outline" onClick={onDone}>{t("portal.form.cancel")}</Button>
      </div>
    </form>
  );
}
